export default "__VITE_ASSET__B$$BY0dI__"